
import * as data from './data';

export default {
    data
}
